/**
 * Shown on a school surface (Orders / Production Records / Settings) when the
 * signed-in user has a school org but Ordo hasn't provisioned its campus
 * (SCHOOL_CAMPUS location) yet. Replaces the alarming "No schools linked"
 * support state with a friendly "we're still setting up your campus" placeholder
 * for that interim window.
 */

import { EmptyState } from '@ordo/ui/empty-state'
import { School } from 'lucide-react'

type Surface = 'orders' | 'production' | 'settings'

const SURFACE_COPY: Record<Surface, string> = {
  orders: 'Ordering will appear here once Ordo finishes setting up your campus.',
  production: 'Production records will appear here once Ordo finishes setting up your campus.',
  settings: 'School settings will be available once Ordo finishes setting up your campus.',
}

export function SchoolSetupPendingEmptyState({
  surface,
  schoolName,
}: {
  surface: Surface
  schoolName?: string | null
}) {
  return (
    <EmptyState
      icon={<School className="h-12 w-12" />}
      title={schoolName ? `Setting up ${schoolName}` : 'Your school is almost ready'}
      description={SURFACE_COPY[surface]}
      padding="lg"
    />
  )
}
